import { createSelector } from 'reselect';
import createReducer from 'granite-admin/utils/ducks/create-reducer';

// ActionsNames - <NOUN>/<VERB>_<NOUN>
const UPDATE_MASTER_CONFIGURATION = 'common/panelPermissions/UPDATE_MASTER_CONFIGURATION';

// Action creator name: <VERB><NOUN>
// Export actions

//update configs in ducks
export function updateMasterConfiguration(data, path) {
  return {
    type: UPDATE_MASTER_CONFIGURATION,
    data: data,
    path: path
  };
}

// state name - <NOUN>
const defaultState = {
  masterConfig: []
};

// Reducers - <NOUN>_<VERB>_REDUCER
function UPDATE_MASTER_CONFIGURATION_REDUCER(state, action) {
  const newState = {
    ...state.masterConfig
  };
  let newAction = {};
  const path = action.path;
  const formattedData = formatMasterConfig(action.data);
  if (path) newAction[path] = [...formattedData];
  const updatedData = {
    ...newAction,
    ...newState
  };
  return Object.assign({}, state, {
    masterConfig: updatedData
  });
}
const handlers = {
  [UPDATE_MASTER_CONFIGURATION]: UPDATE_MASTER_CONFIGURATION_REDUCER
};

// Selectors
const MasterConfigSelector = state => state.common.masterConfig;
export const updateMasterConfig = createSelector(MasterConfigSelector, state => state.masterConfig);

// export reducers as default
export default createReducer(defaultState, handlers);

//function to format config data
const formatMasterConfig = data => {
  if (!data.length) return [];
  let dependentFieldsArr = [];

  //add selectedValue key to denote the value in the parent field on which the rules work.
  if (data.length) {
    data.forEach(i => {
      const {
        field_group_visibility,
        option_visibility,
        ...rest
      } = i;
      if (i.field_group_visibility && Object.keys(i.field_group_visibility).length) {
        Object.keys(i.field_group_visibility).forEach(k => {
          let j = i.config_master_light === false ? +k : k;
          dependentFieldsArr.push({
            selectedValue: i.value_type === 'CHECKBOX' || i.value_type === 'BOOLEAN' ? Boolean(j) : j,
            key: i.key,
            hidden: i['field_group_visibility'][j].hidden,
            visible: i['field_group_visibility'][j].visible,
            ...rest
          });
        });
      } else {
        dependentFieldsArr.push({
          key: i.key,
          ...rest
        });
      }
    });
  }

  //key denotes the field on which the rules work, visible values are the options in the dropdown, visibleON is the parent field, and selected parent value is the value in the parent field on which the rules work
  let formattedArr = [];
  dependentFieldsArr.forEach(i => {
    if (i.visible && Object.keys(i.visible).length) {
      Object.keys(i.visible).forEach(j => {
        //find child and append rest values (ex - extra_data) to child (not available in this loop)
        let dependentChild = dependentFieldsArr.find(child => child.key === j);
        formattedArr.push({
          ...dependentChild,
          key: j,
          visibleValues: i['visible'][j]['visible_values'],
          visibleOn: i.key,
          selectedParentValue: i.selectedValue
        });
      });
    }
    if (i.hidden && i.hidden.length) {
      i.hidden.forEach(k => {
        //find child and append rest values (ex - extra_data) to child (not available in this loop)
        let dependentChild = dependentFieldsArr.find(child => child.key === k);
        formattedArr.push({
          ...dependentChild,
          key: k,
          selectedParentValue: i.selectedValue,
          hiddenOn: i.key
        });
      });
    }
  });

  //add value type in all the objects for each poosible option
  formattedArr = formattedArr.map(o => {
    const duplObj = data.find(a => a.key === o.key);
    if (duplObj) {
      return {
        ...o,
        value_type: duplObj.value_type,
        possible_values: duplObj.possible_values
      };
    } else {
      return o;
    }
  });
  data.forEach(t => {
    if (!formattedArr.find(k => k.key === t.key)) {
      formattedArr.push(t);
    }
  });
  return formattedArr;
};